var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 18H21.9999V20H15.2499L17.2499 18ZM4.74988 20L2.62488 17.875C2.24154 17.4917 2.04571 17.0167 2.03738 16.45C2.02904 15.8833 2.21654 15.4 2.59988 15L13.5999 3.6C13.9832 3.2 14.454 3 15.0124 3C15.5707 3 16.0415 3.19167 16.4249 3.575L21.3999 8.55C21.7832 8.93333 21.9749 9.40833 21.9749 9.975C21.9749 10.5417 21.7832 11.0167 21.3999 11.4L12.9999 20H4.74988ZM12.1499 18L19.9999 9.95L15.0499 5L3.99988 16.4L5.59988 18H12.1499Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.d18de0f5e55a3f58132a750640b5c7d7.svg";
export { ForwardRef as ReactComponent };